import './App.css';
import { useState, useCallback } from 'react';
import { useAudio } from './useAudio';
import HomeScreen from './HomeScreen';
import PlayerScreen from './PlayerScreen';

function App() {
  const [screen, setScreen] = useState('home');
  const [selectedTrack, setSelectedTrack] = useState(null);

  const { toggle, isPlaying, isLoading, analyserRef, hasEnded } = useAudio();

  // Called from a tap on a track card — this IS a user gesture, so toggle()
  // can safely create the AudioContext synchronously (required for iOS Safari).
  const handleSelectTrack = useCallback(
    (track) => {
      setSelectedTrack(track);
      toggle(); // begins AudioContext init + buffer load + playback
      setScreen('player');
    },
    [toggle],
  );

  const handleBack = useCallback(() => {
    if (isPlaying) toggle(); // fade out and pause
    setScreen('home');
  }, [isPlaying, toggle]);

  if (screen === 'player' && selectedTrack) {
    return (
      <PlayerScreen
        track={selectedTrack}
        toggle={toggle}
        isPlaying={isPlaying}
        isLoading={isLoading}
        analyserRef={analyserRef}
        hasEnded={hasEnded}
        onBack={handleBack}
      />
    );
  }

  return <HomeScreen onSelectTrack={handleSelectTrack} />;
}

export default App;
